import { useMemo } from "react";

import { useSurvey } from "../../../hooks/useSurvey";

export const useParticipantData = (surveyId: string) => {
	const { survey } = useSurvey({ surveyId });

	return useMemo(
		() => ({
			survey,
			selectionObjectId: survey?.participantSelection?.selectionObjectId,
			isParticipantSelectionEnabled: survey?.participantSelection?.enabled,
			hasSelectionObject: !!survey?.participantSelection?.selectionObjectId,
		}),
		[survey]
	);
};
